import { makeAutoObservable } from "mobx";

class SimpleModalStore {
  content = null;
  open = false;
  width = "80%";
  height = "80%";

  constructor() {
    makeAutoObservable(this);
  }

  openModal({ content, width = "80%", height = "80%" }) {
    this.content = content;
    this.open = true;
    this.width = width;
    this.height = height;
  }

  closeModal() {
    this.open = false;
    this.content = null;
  }
}

export default new SimpleModalStore();
